import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { ProductKeys } from '~/types/ProductEnums';
import { convertCapacityUnit } from '~/helpers/convertCapacityUnit';
import { deletePropertyIfValueEmptyOrUndefined } from '~/composables/useObjectsFunctions';
import { getFacetProducts } from '~/composables/_next/facetGetters';
import { getCapacityString } from '~/helpers/convertCapacityUnit';
function getProductUsageType(locale, product) {
  var _product$attributesRa;
  var attributeValue = null;
  product === null || product === void 0 ? void 0 : (_product$attributesRa = product.attributesRaw) === null || _product$attributesRa === void 0 ? void 0 : _product$attributesRa.forEach(function (attribute) {
    if (attribute.name === 'usage-type') {
      var _attribute$value$labe, _attribute$value, _attribute$value$labe2;
      attributeValue = (_attribute$value$labe = (_attribute$value = attribute.value) === null || _attribute$value === void 0 ? void 0 : (_attribute$value$labe2 = _attribute$value.label) === null || _attribute$value$labe2 === void 0 ? void 0 : _attribute$value$labe2[locale]) !== null && _attribute$value$labe !== void 0 ? _attribute$value$labe : '';
    }
  });
  return attributeValue;
}
var getMainImage = function getMainImage(product) {
  var _product$images, _product$images$;
  if (!product) {
    return null;
  }
  var allImages = product.images;
  var taggedImage = allImages.find(function (image) {
    return image.label ? image.label.trim().toUpperCase() === 'PLP' : null;
  });
  return taggedImage ? taggedImage.url : (product === null || product === void 0 ? void 0 : (_product$images = product.images) === null || _product$images === void 0 ? void 0 : (_product$images$ = _product$images[0]) === null || _product$images$ === void 0 ? void 0 : _product$images$.url) || '';
};
var removeProductFromWishlist = function removeProductFromWishlist(wishlist, removeItemFromWishlist) {
  return function (productItem) {
    var productsInWishlist = computed(function () {
      var _wishlist$value;
      return ((_wishlist$value = wishlist.value) === null || _wishlist$value === void 0 ? void 0 : _wishlist$value.lineItems) || [];
    });
    var product = productsInWishlist.value.find(function (wishlistProduct) {
      return wishlistProduct.variant.sku === productItem.sku;
    });
    removeItemFromWishlist({
      product: product
    });
  };
};
var getVariants = function getVariants(products) {
  // @ts-ignore
  var variants = getFacetProducts(products, {
    master: false
  });
  var masterVariants = variants.filter(function (v) {
    return v._master;
  });

  // Restore nested variants from VSF mappings
  variants.filter(function (v) {
    return !v._master;
  }).forEach(function (v) {
    var master = masterVariants.find(function (mv) {
      return mv._id === v._id;
    });
    if (master) {
      master.variants = master.variants || [];
      master.variants.push(v);
    }
  });
  return masterVariants;
};
var _isVariantNotInStock = function _isVariantNotInStock(attributes) {
  var _attributes$find;
  var isSellableKey = attributes === null || attributes === void 0 ? void 0 : (_attributes$find = attributes.find(function (_ref) {
    var name = _ref.name;
    return name === ProductKeys.isSellable;
  })) === null || _attributes$find === void 0 ? void 0 : _attributes$find.value.key;
  return isSellableKey !== ProductKeys.inStock;
};
var getSellable = function getSellable(product) {
  var _product$variants;
  return product && !![product.attributesRaw].concat(((_product$variants = product.variants) === null || _product$variants === void 0 ? void 0 : _product$variants.map(function (v) {
    return v === null || v === void 0 ? void 0 : v.attributesRaw;
  })) || []).find(function (attrs) {
    return !_isVariantNotInStock(attrs);
  });
};
var _getRawAttribute = function _getRawAttribute(variant, label) {
  var _variant$attributesRa;
  return variant === null || variant === void 0 ? void 0 : (_variant$attributesRa = variant.attributesRaw) === null || _variant$attributesRa === void 0 ? void 0 : _variant$attributesRa.find(function (_ref2) {
    var name = _ref2.name;
    return name === label;
  });
};
var _getSellableVariants = function _getSellableVariants(variants) {
  return variants.filter(function (v) {
    var field = _getRawAttribute(v, ProductKeys.isSellable);
    return field && field.value.key === ProductKeys.inStock;
  });
};
var _sortByCapacityAscending = function _sortByCapacityAscending(a, b) {
  var calculateCapacity = function calculateCapacity(v) {
    var _getRawAttribute2, _getRawAttribute2$val, _getRawAttribute3;
    return convertCapacityUnit(_defineProperty(_defineProperty({}, ProductKeys.capacityUnit, (_getRawAttribute2 = _getRawAttribute(v, ProductKeys.capacityUnit)) === null || _getRawAttribute2 === void 0 ? void 0 : (_getRawAttribute2$val = _getRawAttribute2.value) === null || _getRawAttribute2$val === void 0 ? void 0 : _getRawAttribute2$val.key), ProductKeys.capacity, (_getRawAttribute3 = _getRawAttribute(v, ProductKeys.capacity)) === null || _getRawAttribute3 === void 0 ? void 0 : _getRawAttribute3.value));
  };
  return calculateCapacity(a) - calculateCapacity(b);
};
var _getCapacityValues = function _getCapacityValues(variant) {
  var _getRawAttribute4, _getRawAttribute5, _getRawAttribute5$val, _getRawAttribute6, _getRawAttribute6$val;
  return "".concat((_getRawAttribute4 = _getRawAttribute(variant, 'capacity')) === null || _getRawAttribute4 === void 0 ? void 0 : _getRawAttribute4.value).concat((_getRawAttribute5 = _getRawAttribute(variant, 'capacity-unit')) === null || _getRawAttribute5 === void 0 ? void 0 : (_getRawAttribute5$val = _getRawAttribute5.value) === null || _getRawAttribute5$val === void 0 ? void 0 : _getRawAttribute5$val.key).concat((_getRawAttribute6 = _getRawAttribute(variant, 'capacity-type')) === null || _getRawAttribute6 === void 0 ? void 0 : (_getRawAttribute6$val = _getRawAttribute6.value) === null || _getRawAttribute6$val === void 0 ? void 0 : _getRawAttribute6$val.key);
};
var getProductAttrsStringForQueryParams = function getProductAttrsStringForQueryParams(variant) {
  var _getRawAttribute7, _getRawAttribute8, _getRawAttribute8$val, _getRawAttribute9, _getRawAttribute9$val;
  var attrs = {
    'capacity': (_getRawAttribute7 = _getRawAttribute(variant, 'capacity')) === null || _getRawAttribute7 === void 0 ? void 0 : _getRawAttribute7.value,
    'capacity-unit': (_getRawAttribute8 = _getRawAttribute(variant, 'capacity-unit')) === null || _getRawAttribute8 === void 0 ? void 0 : (_getRawAttribute8$val = _getRawAttribute8.value) === null || _getRawAttribute8$val === void 0 ? void 0 : _getRawAttribute8$val.key,
    'color': (_getRawAttribute9 = _getRawAttribute(variant, 'color')) === null || _getRawAttribute9 === void 0 ? void 0 : (_getRawAttribute9$val = _getRawAttribute9.value) === null || _getRawAttribute9$val === void 0 ? void 0 : _getRawAttribute9$val.key
  };
  deletePropertyIfValueEmptyOrUndefined(attrs);
  var queryString = '';
  if (Object.keys(attrs).length) {
    queryString = '?';
    Object.keys(attrs).forEach(function (key, index) {
      queryString += "".concat(index > 0 ? '&' : '').concat(key, "=").concat(attrs[key]);
    });
    return queryString;
  }
  return queryString;
};
var _sortAlphabeticallyByColorsRawAttribute = function _sortAlphabeticallyByColorsRawAttribute(a, b) {
  var getColor = function getColor(v) {
    var _getRawAttribute0, _getRawAttribute0$val;
    return (_getRawAttribute0 = _getRawAttribute(v, ProductKeys.color)) === null || _getRawAttribute0 === void 0 ? void 0 : (_getRawAttribute0$val = _getRawAttribute0.value) === null || _getRawAttribute0$val === void 0 ? void 0 : _getRawAttribute0$val.key;
  };
  var firstLabel = getColor(a);
  var secondLabel = getColor(b);
  if (firstLabel > secondLabel) return 1;
  if (firstLabel < secondLabel) return -1;
  return 0;
};
var getActiveProduct = function getActiveProduct(product) {
  var masterSku = product.sku;
  if (!_isVariantNotInStock(product.attributesRaw)) return product;
  var variants = [product].concat(_toConsumableArray(product.variants || []));
  var sellableVariants = _getSellableVariants(variants).sort(_sortByCapacityAscending);
  if (sellableVariants.length < 1) return product;
  var sellableVariant = sellableVariants.filter(function (v) {
    return _getCapacityValues(v) === _getCapacityValues(sellableVariants[0]);
  }).sort(_sortAlphabeticallyByColorsRawAttribute)[0];
  sellableVariant.masterSku = masterSku;
  return sellableVariant;
};
function getCapacity(locale, product) {
  var _product$attributesRa2, _product$attributesRa3, _capacityUnit$value;
  var capacity = product === null || product === void 0 ? void 0 : (_product$attributesRa2 = product.attributesRaw) === null || _product$attributesRa2 === void 0 ? void 0 : _product$attributesRa2.find(function (attribute) {
    return (attribute === null || attribute === void 0 ? void 0 : attribute.name) === ProductKeys.capacity;
  });
  var capacityUnit = product === null || product === void 0 ? void 0 : (_product$attributesRa3 = product.attributesRaw) === null || _product$attributesRa3 === void 0 ? void 0 : _product$attributesRa3.find(function (attribute) {
    return (attribute === null || attribute === void 0 ? void 0 : attribute.name) === ProductKeys.capacityUnit;
  });
  return getCapacityString(capacity === null || capacity === void 0 ? void 0 : capacity.value, capacityUnit === null || capacityUnit === void 0 ? void 0 : (_capacityUnit$value = capacityUnit.value) === null || _capacityUnit$value === void 0 ? void 0 : _capacityUnit$value.label[locale]);
}
var getIsNewProduct = function getIsNewProduct(product) {
  var _product$attributesRa4;
  var attribute = product === null || product === void 0 ? void 0 : (_product$attributesRa4 = product.attributesRaw) === null || _product$attributesRa4 === void 0 ? void 0 : _product$attributesRa4.find(function (attr) {
    return attr.name === ProductKeys.isNewProduct;
  });
  return attribute ? attribute.value : null;
};
export { getProductUsageType, getMainImage, removeProductFromWishlist, getVariants, getSellable, getActiveProduct, getCapacity, getIsNewProduct, getProductAttrsStringForQueryParams };